export const UIHelper = {
    bottomNavigationMenuItems: {
        'home': 'home',
        'profile': 'profile',
        'markets': 'markets',
        'wallets': 'wallets',
        'market': 'market',
    },
    classNames
};

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}
